/**
 * Settings and configs that are shared in multiple places
 */

 export const SHOPIFY_API_VERSION = '/api/2023-10'

// The root paths that are handled by Shopify. These get auto-redirected to.
export const SHOPIFY_ROOT_PATHS = [
	'cart',
	'pages',
	'apps',
	'\\w+\/checkouts',
	'\\w+\/orders',
	'challenge',
	'tools',
]

// Cookie name for the count of items in the cart
export const CART_COUNT_KEY = 'cartCount'

// Cookie name for the storefront api cart id
export const CART_ID_KEY = 'cartId'

// Cookie name for the storefront api customer data
export const CUSTOMER_ID_KEY = 'customerId'

// GTM Event used when newsletter is used succesfully
export const IDENTIFY_EMAIL_EVENT = 'Newsletter Signup'

// GTM Event when a Form Block (Netlify Form) is submitted successfully
export const IDENTIFY_FORM_EVENT = 'Form Submit'

// UTM query params
export const UTM_KEYS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_term',
	'utm_content',
	'gclid',
]
